import dayjs from 'dayjs';

import { ISalesDetailsPayment, ISalesDetailsPaymentState } from '../types/sales-details.type';

export class SalesDetailsHelper {
  /**
   * Get payment cell color
   *
   * @param payment
   */
  static getPaymentColor(payment: ISalesDetailsPayment): string {
    if (payment.state === ISalesDetailsPaymentState.completed) {
      return '#85F081';
    }

    if (
      dayjs().isBefore(dayjs(payment.dueDate)) ||
      (payment.state === ISalesDetailsPaymentState.processing && payment.paidDate)
    ) {
      return '#f6da7e';
    }

    return '#f08781';
  }

  /**
   * Check if payment is failed
   *
   * @param payment
   * @returns
   */
  static isFailed(payment: ISalesDetailsPayment): boolean {
    if (payment.state === ISalesDetailsPaymentState.completed) {
      return false;
    }

    if (
      dayjs().isBefore(dayjs(payment.dueDate)) ||
      (payment.state === ISalesDetailsPaymentState.processing && payment.paidDate)
    ) {
      return false;
    }

    return true;
  }
}
